import { TReduxActions } from '../../../types/redux';
import { TName } from '../../../types/newReview';
import { ENewReviewForm } from '../../../actions/newReview/newReviewsAction';
import { ENameActionTypes } from '../../../actions/newReview/nameActions';

export const defaultValue = {
  value: null,
};

export function nameReviewReducer(state: TName = defaultValue, { type, payload }: TReduxActions): TName {
  if (type === ENameActionTypes.SetName) {
    return {
      value: payload as string,
    };
  }

  if (type === ENewReviewForm.Clear) {
    return defaultValue;
  }

  return state;
}
